import React from "react";
import auth from "../../services/authService";
import "./SideDrawer.css";
import { NavLink } from "react-router-dom";
import LinkButton from "../common/linkButton";

const SideDrawer = ({ show, newBlankProposal }) => {
  let drawerClasses = "side-drawer";
  if (show) {
    drawerClasses = "side-drawer open";
  }

  const user = auth.getCurrentUser();

  return (
    <nav className={drawerClasses}>
      <ul>
        <li>{user && <NavLink to="/proposals">Home</NavLink>}</li>
        <li>
          {user && (
            <LinkButton
              className="btn btn-success"
              style={{ color: "white", padding: "20 25px", fontSize: "25px" }}
              to="/proposals/step-guide"
              onClick={() => newBlankProposal()}
            >
              Get Started
            </LinkButton>
          )}
        </li>
        <li>{user && <NavLink to="/submissions">Submissions</NavLink>}</li>
        <li>{user && <NavLink to="/user">Settings</NavLink>}</li>
        <li>
          {!user && <NavLink to="/login">Login</NavLink>}
          {user && <NavLink to="/logout">Logout</NavLink>}
        </li>
      </ul>
    </nav>
  );
};

export default SideDrawer;
